<template>
  <div class="add-container">
    <el-col :span="22" :offset="1" style="margin-top: 10px">
      <el-card class="box-card" shadow="hover" style="height: 820px;overflow-y: auto;">
        <!--       进度条-->
        <el-col :span="22" :offset="1">
          <el-steps :active="current_step">
            <el-step
              title="选择专业"
              description="请选择您需要的专业"
            ></el-step>
            <el-step
              title="需求人数"
              description="请填写相关专业需求人数"
            ></el-step>
            <el-step
              title="单位信息"
              description="最后请完善您的单位信息"
            ></el-step>
            <el-step title="提交成功"></el-step>
          </el-steps>
        </el-col>
        <step-section1
          v-if="current_step == 1"
          ref="step1SectionRef"
          :step-one-data="stepOneData"
        ></step-section1>
        <step-section2
          v-else-if="current_step == 2"
          ref="step2SectionRef"
          :step-two-data="stepTwoData"
        ></step-section2>
        <step-section3
          v-else-if="current_step == 3"
          ref="step3SectionRef"
        ></step-section3>
        <step-section4 v-else-if="current_step == 4"></step-section4>
        <!--        第一步的按钮-->
        <el-col :span="24" style="text-align: center">
          <el-button v-if="current_step == 1" type="primary" @click="next(12)">
            选好了，下一步
          </el-button>
          <el-button v-if="current_step == 2" type="info" @click="next(21)">
            重选专业
          </el-button>
          <el-button v-if="current_step == 2" type="primary" @click="next(23)">
            下一步
          </el-button>
          <!--          <el-button v-if="current_step == 3" type="info" @click="next(32)">-->
          <!--            上一步-->
          <!--          </el-button>-->
          <el-button
            v-if="current_step == 3"
            type="primary"
            :loading="showLoading"
            @click="next(34)"
          >
            确认提交
          </el-button>
        </el-col>
      </el-card>
    </el-col>

       <!-- 提示填写调查问卷 -->
    <el-dialog
  title="消息"
  :visible.sync="wenjuanDialogVisible"
  width="50%"
  top="2vh"
  :append-to-body="true"
  :close-on-click-modal="false"
  :show-close="false"
  center>
  <p>尊敬的各位用人单位负责人：</p>
  <p>您们好！</p>
  <p>衷心感谢贵单位长期以来对我校毕业生就业工作的大力支持与对我校毕业生的悉心栽培！我校与贵单位在人才供需方面建立的紧密合作，是推动双方共同发展的重要基石。</p>
  <p>毕业生的职业发展状况与用人单位的评价，是检验我校办学成效、优化教育供给最为宝贵的“试金石”与“风向标”。为此，我们诚挚地邀请您们参与本年度“毕业生就业情况与人才培养质量”问卷调查工作。</p>
  <p>我们深知贵单位业务繁忙，但依然恳请您在百忙之中拨冗参与。本次问卷调查将主要通过在线形式进行，预计占用您10-15分钟时间。</p>
  <p>调研时间：2025年11月20日至2026年03月24日</p>
  <p>调查方式：邮件、短信、公开链接和二维码调研</p>
  <p>（1）用人单位点击邮件/短信内答题链接即可参与。</p>
  <p>（2）公开链接调研：可直接点击如下链接参与</p>
  <p><a href="https://dm.njcedu.com/answer?id=15300" target="_blank">https://dm.njcedu.com/answer?id=15300</a> </p>
  <p>（3）或扫下面的二维码进行作答：</p>
  <p><img width="150px" src="../assets/wenjuanewm.png" alt="" /></p>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="clooseWenjuanDialog()">关闭弹窗继续提交</el-button>
  </span>
</el-dialog> 
  </div>
</template>

<script>
  import StepSection1 from '@/project/add-section/stepSection1'
  import StepSection2 from '@/project/add-section/stepSection2'
  import StepSection3 from '@/project/add-section/stepSection3'
  import StepSection4 from '@/project/add-section/stepSection4'
  import axios from 'axios'
  export default {
    name: 'Add',
    components: { StepSection4, StepSection3, StepSection2, StepSection1 },
    data() {
      return {
        current_step: 1,
        //第一步中需要传进去的数据
        stepOneData: { checkBoxGroupBenke: [], checkBoxGroupShuoshi: [],checkBoxGroupBoshi: [], inputShuoshitextarea:''},
        //第二步中需要传进去的数据
        stepTwoData: {
          checkboxGroupBenke_xuqiu: [],
          checkboxGroupShuoshi_xuqiu: [],
          checkBoxGroupBoshi_xuqiu: [],
          inputShuoshitextarea:''
        },
        checkboxGroupBenke_xuqiu_majors: [],
        checkboxGroupShuoshi_xuqiu_majors: [],
        checkboxGroupBoshi_xuqiu_majors: [],
        inputShuoshitextarea:'',
        showLoading: false,
        wenjuanDialogVisible:false,
      }
    },
    methods: {
      clooseWenjuanDialog(){
        var that = this
        that.wenjuanDialogVisible = false
        // 数据验证通过

          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          // 延时执行
          setTimeout(function () {
            // 验证全部通过，提交数据到后台
            let dwxx_id = that.$refs['step3SectionRef'].dwxx_id
            if (dwxx_id != '') {
              // 提交专业需求信息入库，
              axios
                .post(
                  'https://cfp.1kawk.com/lantu_s_php/submit_xuqiu_data.php',
                  {
                    bk_xuqiu: that.stepTwoData.checkboxGroupBenke_xuqiu,
                    ss_xuqiu: that.stepTwoData.checkboxGroupShuoshi_xuqiu,
                    ss_xuqiu_textarea:that.stepTwoData.inputShuoshitextarea,
                    dwxx_id: dwxx_id,
                  }
                )
                .then(function (res) {
                  if (res.data.status == 'success') {
                    //  提交成功
                    that.current_step = 4
                    loading.close();
                  } else {
                    that.$message({
                      type: 'error',
                      message: '网络问题，请重试！',
                    })
                    that.showLoading = false
                    loading.close();
                  }
                })
            }else{
              that.showLoading = false
              loading.close();
            }
          }, 6 * 1000)

      },
      sleep(ms) {
return new Promise(resolve => setTimeout(resolve, ms));
},
      next(num) {
        let that = this
        if (num == 21) {
          this.checkboxGroupBenke_xuqiu_majors = this.stepOneData.checkBoxGroupBenke
          this.checkboxGroupShuoshi_xuqiu_majors = this.stepOneData.checkBoxGroupShuoshi
          this.inputShuoshitextarea = this.stepOneData.inputShuoshitextarea
          this.current_step = 1
        } else if (num == 12) {
          // 设定 step1Data 的数据
          let benkeMajors = this.$refs['step1SectionRef'].checkboxGroupBenke
          let shuoshiMajors = this.$refs['step1SectionRef'].checkboxGroupShuoshi
          let inputShuoshitextarea = this.$refs['step1SectionRef'].inputShuoshitextarea
          this.stepOneData = {
            checkBoxGroupBenke: benkeMajors,
            checkBoxGroupShuoshi: shuoshiMajors,
            inputShuoshitextarea: inputShuoshitextarea,
          }
          // 设定 step2Data 的数据
          let deal_data = this.deal_step_two_data(benkeMajors, shuoshiMajors)
          this.stepTwoData = {
            checkboxGroupBenke_xuqiu: deal_data.new_checkboxGroupBenke_xuqiu,
            checkboxGroupShuoshi_xuqiu:
              deal_data.new_checkboxGroupShuoshi_xuqiu,
              inputShuoshitextarea:this.$refs['step1SectionRef'].inputShuoshitextarea
          }
          //将步骤调为第二部
          this.current_step = 2
        } else if (num == 23) {
          this.current_step = 3
        } else if (num == 32) {
          this.current_step = 2
        } else if (num == 34) {
          this.showLoading = true
          this.$refs['step3SectionRef'].checkForm()
          

          setTimeout(() => {
            let step3Status =  this.$refs['step3SectionRef'].checkFormStatus
            if (step3Status == '0'){
          // 第三步的表单验证未通过
            that.showLoading = false
            that.$message({
              type: 'error',
              message: '表单数据内容验证不通过！',
            })
            return false;
          }else if(step3Status == '1'){
            that.showLoading = false
            return false;
          }else if(step3Status == '2'){
            that.showLoading = false
            return false;
          }else if(step3Status == '3'){
            that.showLoading = false
            return false;
          }

          // 验证通过不打开弹窗提示  并触发clooseWenjuanDialog方法处理数据
          // that.wenjuanDialogVisible=true
          that.clooseWenjuanDialog();


          }, 1500);
          

          
        }
      },

      // 处理专业到需求人数的数据
      // 传入benkeMajors，benkeMajors 传出 {new_checkboxGroupBenke_xuqiu ，new_checkboxGroupShuoshi_xuqiu}
      deal_step_two_data(benkeMajors, shuoshiMajors) {
        let new_checkboxGroupBenke_xuqiu = []
        let new_checkboxGroupShuoshi_xuqiu = []
        //本科需求数据处理
        for (let y = 0; y < benkeMajors.length; y++) {
          let checkboxGroupBenke_xuqiu = this.stepTwoData
            .checkboxGroupBenke_xuqiu
          let checkboxGroupBenke_xuqiu_majors = this
            .checkboxGroupBenke_xuqiu_majors
          if (checkboxGroupBenke_xuqiu_majors.indexOf(benkeMajors[y]) != -1) {
            for (let z = 0; z < checkboxGroupBenke_xuqiu.length; z++) {
              if (benkeMajors[y] == checkboxGroupBenke_xuqiu[z]['zymc']) {
                // 之前已经存在
                new_checkboxGroupBenke_xuqiu.push(checkboxGroupBenke_xuqiu[z])
              }
            }
          } else {
            // 新添加的专业
            new_checkboxGroupBenke_xuqiu.push({
              zymc: benkeMajors[y],
              need_num: 1,
            })
          }
        }
        //硕士需求数据处理
        for (let y = 0; y < shuoshiMajors.length; y++) {
          let checkboxGroupShuoshi_xuqiu = this.stepTwoData
            .checkboxGroupShuoshi_xuqiu
          let checkboxGroupShuoshi_xuqiu_majors = this
            .checkboxGroupShuoshi_xuqiu_majors
          if (
            checkboxGroupShuoshi_xuqiu_majors.indexOf(shuoshiMajors[y]) != -1
          ) {
            for (let z = 0; z < checkboxGroupShuoshi_xuqiu.length; z++) {
              if (shuoshiMajors[y] == checkboxGroupShuoshi_xuqiu[z]['zymc']) {
                // 之前已经存在
                new_checkboxGroupShuoshi_xuqiu.push(
                  checkboxGroupShuoshi_xuqiu[z]
                )
              }
            }
          } else {
            // 新添加的专业
            new_checkboxGroupShuoshi_xuqiu.push({
              zymc: shuoshiMajors[y],
              need_num: 1,
            })
          }
        }
        return {
          new_checkboxGroupBenke_xuqiu: new_checkboxGroupBenke_xuqiu,
          new_checkboxGroupShuoshi_xuqiu: new_checkboxGroupShuoshi_xuqiu,
        }
      },
    },
  }
</script>

<style scoped>
  .add-container {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: #409eff;
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/project/add.vue